import React from 'react';
import Button from '../Button';
import { IOrderLine, IMenuTopNavProps } from '@orderingstack/ordering-types';
import { isCartEmpty } from '../../utils';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Cart } from '../../icons/cart.svg';
import { ReactComponent as ArrowLeft } from '../../icons/arrow_left.svg';
import { getGroupedBucketLines } from '@orderingstack/front-hooks';

export default function TopNav({
  order,
  goToCheckout,
  goToStart,
}: IMenuTopNavProps) {
  const groupedLines: IOrderLine[] =
    getGroupedBucketLines(order?.buckets) || [];
  const itemsCount = groupedLines.length;

  const { t } = useTranslation();
  return (
    <div className="flex flex-row grow-0 justify-between items-center px-6 w-full h-[178px]">
      <Button
        onClick={goToStart}
        className="!text-fontColor-btnSecondary !bg-bgColor-btnSecondary"
      >
        <ArrowLeft fill="var(--font-color-btn-secondary)" />
        {/*<div className="ml-6">{t('3e.kiosk.menu.topNav.start')}</div>*/}
      </Button>
      <Button
        disabled={isCartEmpty(order)}
        onClick={() => goToCheckout({ showUpsell: false })}
      >
        <div className="mr-6">{t('3e.kiosk.menu.topNav.cart')}</div>
        <Cart
          fill={
            isCartEmpty(order)
              ? 'var(--font-color-btn-disabled)'
              : 'var(--font-color-btn-primary)'
          }
        />
        {itemsCount > 0 && <span className="ml-2">({itemsCount})</span>}
      </Button>
    </div>
  );
}
